module.exports = __webpack_public_path__ + "img/doc-req.2ee1dbf6.svg";